import React, {useEffect, useState} from 'react';

import {View} from '../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import * as AuthActions from '../../store/actions/authActions';

import {useDispatch, useSelector} from 'react-redux';

import AppConfig from '../../AppConfig';
import ActivityIndicatorWrapper from '../../components/public/UI/ActivityIndicatorWrapper';
import {useNavigate} from 'react-router-dom';
import {GetLang, SetLang} from "../../LocalStorageFunctions";


const LogoutScreen = (props) => {
    const navigate = useNavigate();
    const auth = useSelector(state => state.Auth);
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(true);

    useEffect(async () => {
        const response = await fetch(AppConfig.URL + '/Account/Logout/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token,
                'pid': auth.pid
            },
        }
        );

        var json = await response.json();

        if (json.success) {
            const deviceID = localStorage.getItem('deviceID')
            const lang = GetLang()

            localStorage.clear();

            SetLang(lang)
            localStorage.setItem('deviceID', deviceID)

            dispatch(AuthActions.saveAuth({
                pid: undefined,
                passphrase: undefined,
                token: undefined,
                userID: undefined,
                userName: undefined,
                name: undefined,
                type: undefined,
                termsAccepted: undefined,
            }))

            navigate('/', { replace: true });
        }
    }, [])


    if (loading) {
        return <ActivityIndicatorWrapper />
    }

    return <View></View>;
};

export default LogoutScreen;